import { parseUserPermissionsForFE } from '../userPermissions/userPermissions.parsers';
import type { UserGroups, UserGroupsDTO } from './userGroups.types';

export const parseUserGroupsForFE = (userGroupsDTO: UserGroupsDTO): UserGroups =>
  userGroupsDTO.map(({ name, permissions }) => ({
    name,
    permissions: parseUserPermissionsForFE(permissions),
  }));
